import React, { memo } from 'react';
import { TextField, InputLabel, TextFieldProps } from '@material-ui/core';
import { FieldMetaState } from 'react-final-form';
import clsx from 'clsx';
import { formStyles } from './styles';
import { InputFieldProps } from './utils';
import InputFieldWrapper from './InputFieldWrapper';

type InputProps = TextFieldProps & {
  field: InputFieldProps;
  meta: FieldMetaState<string | number>;
  wrapField?: boolean;
};

const InputNew = ({ field, meta, wrapField = true, ...props }: InputProps) => {
  const classes = formStyles();

  const helperText = meta.touched && meta.error ? meta.error : field.helperText;
  const fieldId = field.id || field.name;

  const inputClassName = clsx(props.className, classes.field);

  const content = (
    <>
      <InputLabel htmlFor={fieldId}>{field.label}</InputLabel>
      <TextField
        size="small"
        error={Boolean(meta.touched && meta.error)}
        {...props}
        name={field.name}
        id={fieldId}
        data-qa-id={field.qaId}
        variant="outlined"
        fullWidth
        InputLabelProps={{ shrink: false }}
        inputProps={{ ...props.inputProps, ...field.inputProps }}
        data-testid={field.qaId}
        className={inputClassName}
        helperText={helperText}
      />
    </>
  );

  if (wrapField) {
    return <InputFieldWrapper>{content}</InputFieldWrapper>;
  }

  return content;
};

export default memo(InputNew);
